import {
  ENewbuildingBrokerOfferBookingActions,
  TNewbuildingBrokerOfferBookingActions,
} from 'shared/actions/newbuildingBrokerOfferBooking';
import { INewbuildingBrokerOfferBooking } from 'shared/types/newbuildingBrokerOfferBooking';

const initialState: INewbuildingBrokerOfferBooking = {
  enabled: false,
  callbackWidgetOpened: false,
  galleryBannerAnalyticsSent: false,
};

export const newbuildingBrokerOfferBookingReducer = (
  state: INewbuildingBrokerOfferBooking = initialState,
  action: TNewbuildingBrokerOfferBookingActions,
): INewbuildingBrokerOfferBooking => {
  switch (action.type) {
    case ENewbuildingBrokerOfferBookingActions.SetEnabled:
      return {
        ...state,
        enabled: action.payload,
      };

    case ENewbuildingBrokerOfferBookingActions.OpenCallbackWidget:
      return {
        ...state,
        callbackWidgetOpened: true,
        callbackWidgetClickType: action.payload,
      };

    case ENewbuildingBrokerOfferBookingActions.CloseCallbackWidget:
      return {
        ...state,
        callbackWidgetOpened: false,
        callbackWidgetClickType: undefined,
      };

    case ENewbuildingBrokerOfferBookingActions.SetGalleryBannerAnalyticsSent:
      return {
        ...state,
        galleryBannerAnalyticsSent: true,
      };

    default:
      return state;
  }
};
